import { render, staticRenderFns } from "./ages.vue?vue&type=template&id=883192fa"
import script from "./ages.vue?vue&type=script&lang=js"
export * from "./ages.vue?vue&type=script&lang=js"
import style0 from "./ages.vue?vue&type=style&index=0&id=883192fa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports